import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { addToFavorites } from "./favorisSlice";
import api from "../../services/interceptor";

// Helper function to get API URL
const getApiUrl = (endpoint) => `${process.env.REACT_APP_API_URL}${endpoint}`;
// Helper function to get auth token
const getAuthToken = (getState) => {
  const { user: { token } } = getState();
  const localToken = localStorage.getItem('token') || token;
  if (!localToken) throw new Error("No authentication token found");
  return localToken;
};

// Async Thunks
export const fetchEtablissements = createAsyncThunk(
  "etablissements/fetchEtablissements",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(getApiUrl("etablissements"));
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to load establishments");
    }
  }
);

export const fetchEtablissementsByTag = createAsyncThunk(
  "etablissements/fetchEtablissementsByTag",
  async (tag, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(getApiUrl(`featured-etablissements?${tag}`), {
        // headers: {
        //   'Content-Type': 'application/json',
        //   'Authorization': `Bearer ${token}`,
        // },
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to load establishments by tag");
    }
  }
);

export const fetchEtablissementById = createAsyncThunk(
  "etablissements/fetchEtablissementById",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(getApiUrl(`etablissements/${id}`), {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
      // getRecentlyVisited();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Establishment not found");
    }
  }
);



export const createEtablissement = createAsyncThunk(
  "etablissements/createEtablissement",
  async (etablissementData, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.post(
        getApiUrl("etablissements"),
        etablissementData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      localStorage.setItem('selectedEtablissement', JSON.stringify(response?.data?.etablissement));
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to create establishment");
    }
  }
);
export const updatedEtablissement = createAsyncThunk(
  "etablissements/updateEtablissement",
  async (payload, { rejectWithValue, getState }) => {
    try {

      const { etablissementData, route } = payload;
      // console.log({etablissementData,route})
      const token = getAuthToken(getState);
      const response = await axios.post(
        getApiUrl(route),
        etablissementData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      //  console.log({response})
      // localStorage.setItem('selectedEtablissement', JSON.stringify(response?.data?.etablissement));
      return response.data?.etablissement;
    } catch (err) {
      //  console.log('err',err)
      return rejectWithValue(err.response?.data?.error || "Failed to create establishment");
    }
  }
);
export const FirstupdatedEtablissement = createAsyncThunk(
  "etablissements/updateEtablissement",
  async (payload, { rejectWithValue, getState }) => {
    try {

      const { etablissementData, route } = payload;
      // console.log({etablissementData,route})
      const token = getAuthToken(getState);
      const response = await axios.post(
        getApiUrl(route),
        etablissementData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      //  console.log({response})
      // localStorage.setItem('selectedEtablissement', JSON.stringify(response?.data?.etablissement));
      return response.data?.etablissement;
    } catch (err) {
      //  console.log('err',err)
      return rejectWithValue(err.response?.data?.error || "Failed to create establishment");
    }
  }
);
export const createEtablissementHoraires = createAsyncThunk(
  "etablissements/createEtablissementHoraires",
  async (horaires, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const { etablissements: { selectedEtablissement } } = getState();
      const localEtablissement = JSON.parse(localStorage.getItem('selectedEtablissement'));
      const selectedEtablissementId = selectedEtablissement?.id || localEtablissement?.id;

      const response = await axios.post(
        getApiUrl(`etablissements/${selectedEtablissementId}/horaires`),
        horaires,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to create opening hours");
    }
  }
);

export const createEtablissementPhotos = createAsyncThunk(
  "etablissements/createEtablissementPhotos",
  async (photos, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const { etablissements: { selectedEtablissement } } = getState();
      const localEtablissement = JSON.parse(localStorage.getItem('selectedEtablissement'));
      const selectedEtablissementId = selectedEtablissement?.id || localEtablissement?.id;

      const response = await axios.post(
        getApiUrl(`etablissements/${selectedEtablissementId}/photos`),
        photos,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to upload photos");
    }
  }
);
//delete photos
export const deleteEtablissementPhoto = createAsyncThunk(
  "etablissements/deleteEtablissementPhoto",
  async (photoId, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const { etablissements: { selectedEtablissement } } = getState();


      const response = await axios.delete(
        getApiUrl(`etablissements/photos/${photoId}`),
        {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      return { photoId, data: response.data };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to delete photo");
    }
  }
);
export const updateEtablissementPhotos = createAsyncThunk(
  "etablissements/updateEtablissementPhotos",
  async (photos, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const { etablissements: { selectedEtablissement } } = getState();
      const localEtablissement = JSON.parse(localStorage.getItem('selectedEtablissement'));
      const selectedEtablissementId = selectedEtablissement?.id || localEtablissement?.id;

      const response = await axios.post(
        getApiUrl(`etablissements/${selectedEtablissementId}/photos/update`),
        photos,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to upload photos");
    }
  }
);
export const createEtablissementService = createAsyncThunk(
  "etablissements/createEtablissementService",
  async (data, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const { etablissements: { selectedEtablissement } } = getState();
      const localEtablissement = JSON.parse(localStorage.getItem('selectedEtablissement'));
      const selectedEtablissementId = selectedEtablissement?.id || localEtablissement?.id;

      const response = await axios.post(
        getApiUrl(`services-prestations`),
        data,

        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to upload photos");
    }
  }
);
// In your etablissementSlice.js
export const createPrestation = createAsyncThunk(
  'etablissement/createPrestation',
  async (prestationData, { rejectWithValue }) => {
    try {
      const response = await api.post('/prestations', prestationData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updatePrestation = createAsyncThunk(
  'etablissement/updatePrestation',
  async (prestationData, { rejectWithValue , getState}) => {
    const token = getAuthToken(getState);
    try {
      const response = await api.put(`/prestations/${prestationData.id}`, prestationData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);


export const deletePrestation = createAsyncThunk(
  'etablissement/deletePrestation',
  async (prestationId, { rejectWithValue }) => {
    try {
      const response = await api.delete(`/prestations/${prestationId}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const createPrestationWithService = createAsyncThunk(
  'etablissement/createPrestationWithService',
  async (prestationData, { rejectWithValue }) => {
    try {
      const response = await api.post('/prestations/with-service', prestationData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getMyEtablissement = createAsyncThunk(
  "etablissements/mine",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(getApiUrl(`my-etablissement`), {
        headers: {
          'content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
      // console.log(response.data)
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Establishment not found")
    }
  }
);
export const getRecentlyVisited = createAsyncThunk(
  "etablissements/recentlyVisited",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(getApiUrl(`recently-visited`), {
        headers: {
          'content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
      // console.log(response.data)
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Establishment not found")
    }
  }
);

// Slice
const etablissementSlice = createSlice({
  name: "etablissements",
  initialState: {
    etablissements: [],
    selectedEtablissement: null,
    selectedEtablissementId: null,  // Changed from setSelectedIdGoogle for clarity
    selectedSubEtablissement: null,
    status: "idle",
    createStatus: "idle",
    error: null,
    createError: null,
    etablissementsByTag: [],
    tagStatus: 'idle',
    tagError: null,
    horaires: null,
    services: null,
    recentlyVisited: [],
    recentlyVisitedStatus: "idle",
    recentlyVisitedError: null,
  },
  reducers: {
    setSelectedEtablissement: (state, action) => {
      state.selectedEtablissement = action.payload;
      state.selectedSubEtablissement = null;
    },
    setSelectedSubEtablissement: (state, action) => {
      state.selectedSubEtablissement = action.payload;
    },
    setSelectedEtablissementId: (state, action) => {
      state.selectedEtablissementId = action.payload;
    },
    resetCreateStatus: (state) => {
      state.createStatus = "idle";
      state.createError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch all établissements
      .addCase(fetchEtablissements.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchEtablissements.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.etablissements = action.payload;
      })
      .addCase(fetchEtablissements.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Fetch single établissement
      .addCase(fetchEtablissementById.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchEtablissementById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.selectedEtablissement = action.payload;
      })
      .addCase(fetchEtablissementById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Create établissement
      .addCase(createEtablissement.pending, (state) => {
        state.createStatus = "loading";
        state.createError = null;
      })
      .addCase(createEtablissement.fulfilled, (state, action) => {
        state.createStatus = "succeeded";
        state.etablissements.push(action.payload);
        state.selectedEtablissement = action.payload;
        localStorage.setItem('horaires', JSON.stringify(action.payload));
      })
      .addCase(createEtablissement.rejected, (state, action) => {
        state.createStatus = "failed";
        state.createError = action.payload;
      })
      // update établissement 
      .addCase(updatedEtablissement.pending, (state) => {
        state.updateStatus = 'loading';
      })
      .addCase(updatedEtablissement.fulfilled, (state, action) => {
        state.updateStatus = 'succeeded';
        // state.selectedEtablissement = action.payload;
      })
      .addCase(updatedEtablissement.rejected, (state, action) => {
        state.updateStatus = 'failed';
        state.error = action.payload;
      })
      .addCase(updateEtablissementPhotos.pending, (state) => {
        state.createStatus = 'loading';
      })
      .addCase(updateEtablissementPhotos.fulfilled, (state, action) => {
        state.createStatus = 'succeeded';
        // state.selectedEtablissement = action.payload;
      })
      .addCase(updateEtablissementPhotos.rejected, (state, action) => {
        state.updateStatus = 'failed';
        state.error = action.payload;
      })


      // Fetch établissements by tag
      .addCase(fetchEtablissementsByTag.pending, (state) => {
        state.tagStatus = 'loading';
      })
      .addCase(fetchEtablissementsByTag.fulfilled, (state, action) => {
        state.tagStatus = 'succeeded';
        state.etablissementsByTag = action.payload;
        // filtre 
      })
      .addCase(addToFavorites.fulfilled, (state, action) => {
        // console.log('etablissement by tag favoris', state.etablissementsByTag, action.payload)
        // filtre 
      })
      .addCase(fetchEtablissementsByTag.rejected, (state, action) => {
        state.tagStatus = 'failed';
        state.tagError = action.payload;
      })

      // Create horaires
      .addCase(createEtablissementHoraires.pending, (state, action) => {
        state.createStatus = 'loading';

      })
      .addCase(createEtablissementHoraires.fulfilled, (state, action) => {
        state.horaires = action.payload;
        state.createStatus = "succeeded";
        localStorage.setItem('horaires', JSON.stringify(action.payload));
      })
      // create services etablissement 
      .addCase(createEtablissementService.fulfilled, (state, action) => {
        state.services = action.payload;
        localStorage.setItem('service', JSON.stringify(action.payload));
      })
      // Get Recently Visited
      .addCase(getRecentlyVisited.pending, (state) => {
        state.recentlyVisitedStatus = "loading";
        state.recentlyVisitedError = null;
      })
      .addCase(getRecentlyVisited.fulfilled, (state, action) => {
        state.recentlyVisitedStatus = "succeeded";
        state.recentlyVisited = action.payload;
        // console.log('action.payload', action.payload)
      })
      .addCase(getRecentlyVisited.rejected, (state, action) => {
        state.recentlyVisitedStatus = "failed";
        state.recentlyVisitedError = action.payload;
      })
      //getMyEtablissement
      .addCase(getMyEtablissement.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getMyEtablissement.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.selectedEtablissement = action.payload;
      })
      .addCase(getMyEtablissement.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Handle photo deletion
      .addCase(deleteEtablissementPhoto.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteEtablissementPhoto.fulfilled, (state, action) => {
        state.loading = false;
        const { photoId } = action.payload;

      })
      .addCase(deleteEtablissementPhoto.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export const {
  setSelectedEtablissement,
  setSelectedSubEtablissement,
  setSelectedEtablissementId,
  resetCreateStatus
} = etablissementSlice.actions;

export default etablissementSlice.reducer;